import { render } from "./zhenggaolinchuang-news.vue?vue&type=template&id=6a3d2114&scoped=true"
import script from "./zhenggaolinchuang-news.vue?vue&type=script&lang=js"
export * from "./zhenggaolinchuang-news.vue?vue&type=script&lang=js"

import "./zhenggaolinchuang-news.vue?vue&type=style&index=0&id=6a3d2114&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3d2114"]])

export default __exports__